// src/features/owner/sections/content/HashtagsSection.tsx
import { useOwnerList } from '@/hooks';
import { ownerService } from '@/core/services/ownerService';
import { OwnerPanel, DataTable } from '../../components';
import type { Column } from '../../components';
import type { HashtagRow } from '@/core/models';

export function HashtagsSection() {
  const { data, loading, error } = useOwnerList(() => ownerService.getHashtags());

  const columns: Column<HashtagRow>[] = [
    { key: 'tag', header: 'Hashtag', sortBy: (r) => r.tag, render: (r) => `#${r.tag}` },
    {
      key: 'count',
      header: 'Uses',
      align: 'right',
      sortBy: (r) => r.count,
      render: (r) => String(r.count),
    },
  ];

  if (loading) return <p style={{ opacity: 0.6 }}>Loading…</p>;

  return (
    <OwnerPanel title="Hashtags">
      <DataTable<HashtagRow>
        columns={columns}
        rows={data?.results ?? []}
        rowKey={(r) => r.tag}
        emptyIcon="hash"
        emptyMessage={error ?? 'No hashtag data yet'}
      />
    </OwnerPanel>
  );
}
